import { notification } from "antd";
import i18n from "../../i18n";

/**
 * Throw notification with all errors.
 *
 * @param {*} error
 */
export default function throwError(error) {
  const fields = error?.response?.data?.errors;
  const errors = fields && typeof fields === "object"
    ? Object.values(fields)
        .flatMap((messages) => Array.isArray(messages) ? messages : [messages])
        .filter((message) => typeof message === "string" && message.trim())
        .join(" ")
    : "";
  const message = error?.response?.data?.message;

  notification.error({
    message: "Chyba!",
    description: errors || (typeof message === "string" && message.trim()
      ? message
      : i18n.t("common.requestFailed")),
  });
}
